// extracted by mini-css-extract-plugin
module.exports = {"stats-box":"stats-box___9yaVh","stat-item":"stat-item___2JBOM","legend":"legend___VFqAX","square":"square___3X19r"};